import { useMutation } from '@tanstack/react-query'

import type { ConfigurationVersionUpdate } from '@/features/configuration/contexts/ConfigurationFileContext'
import type { ResourceJsonConfigResponse } from '@/features/resource/configuration/endpoints/resourceJsonConfiguration'
import { updateResourceJson } from '@/features/resource/configuration/endpoints/resourceJsonConfiguration'

export function useUpdateResourceJsonMutation(resourceId: string) {
  const { mutateAsync, ...mutationResult } = useMutation<ResourceJsonConfigResponse, Error, ConfigurationVersionUpdate>(
    {
      mutationFn: (payload) => updateResourceJson(resourceId, payload),
    },
  )

  return {
    updateResourceJson: mutateAsync,
    ...mutationResult,
  }
}
